const DOTO_RECENTLY_VIEWED_KEY = 'doto_recently_viewed_products_v1';

function getRecentlyViewedHandles() {
  try {
    const history = JSON.parse(localStorage.getItem(DOTO_RECENTLY_VIEWED_KEY) || '[]');
    return Array.isArray(history)
      ? history.filter((handle) => typeof handle === 'string' && handle.trim() !== '')
      : [];
  } catch (error) {
    return [];
  }
}

function moneyFormatter() {
  const numberFormatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return {
    format(value) {
      const amount = Number(value || 0);
      return `$ ${numberFormatter.format(Number.isFinite(amount) ? amount : 0)}`;
    }
  };
}

function imageWithWidth(url, width = 520) {
  if (!url) return '';
  return `${url}${url.includes('?') ? '&' : '?'}width=${width}`;
}

function makeTextElement(tag, className, text) {
  const element = document.createElement(tag);
  element.className = className;
  element.textContent = text;
  return element;
}

function getCheapestVariant(product) {
  const variants = Array.isArray(product?.variants) ? product.variants : [];
  if (!variants.length) return null;

  const available = variants.filter((variant) => variant?.available);
  const candidates = available.length ? available : variants;

  return candidates.reduce((cheapest, variant) => {
    if (!cheapest) return variant;
    return Number(variant?.price || Infinity) < Number(cheapest?.price || Infinity)
      ? variant
      : cheapest;
  }, null);
}

function getVariantImage(variant, product) {
  const featured = variant?.featured_image;
  if (typeof featured === 'string') return featured;
  if (featured?.src) return featured.src;
  return product?.featured_image || '';
}

function getVariantUrl(product, variant, config) {
  const baseUrl = product?.url || `${config.rootUrl}products/${product?.handle || ''}`;
  if (!variant?.id) return baseUrl;
  return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}variant=${variant.id}`;
}

function createQuickAdd(product, config) {
  const variant = getCheapestVariant(product);

  const quickAdd = document.createElement('doto-carousel-quick-add');
  quickAdd.className = `doto-carousel-quick-add${!variant?.available ? ' !disabled' : ''}`;
  quickAdd.dataset.productTitle = product.title || '';
  if (variant?.id) quickAdd.dataset.variantId = String(variant.id);

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'doto-carousel-quick-add__button';
  button.title = variant?.available ? 'Agregar al carrito' : 'Agotado';
  button.setAttribute(
    'aria-label',
    variant?.available
      ? `Agregar ${product.title || 'producto'} al carrito`
      : `${product.title || 'Producto'} agotado`
  );

  button.innerHTML = `
    <span class="doto-carousel-quick-add__plus" aria-hidden="true">
      <svg viewBox="0 0 20 20" fill="none">
        <path d="M2.75 3.5h2.1l1.42 7.55a1.55 1.55 0 0 0 1.53 1.27h5.67a1.55 1.55 0 0 0 1.5-1.18L16.2 6H5.35" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="8.15" cy="15.65" r="1.1" fill="currentColor"/>
        <circle cx="14.1" cy="15.65" r="1.1" fill="currentColor"/>
      </svg>
    </span>
    <span class="doto-carousel-quick-add__check" aria-hidden="true">
      <svg viewBox="0 0 20 20" fill="none">
        <path d="m5 10.3 3.1 3.1L15 6.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  `;

  if (!variant?.available) {
    button.disabled = true;
    quickAdd.appendChild(button);
    return quickAdd;
  }

  button.setAttribute('data-doto-carousel-quick-add-button', '');
  quickAdd.appendChild(button);

  return quickAdd;
}

function createProductCard(product, config) {
  const article = document.createElement('article');
  article.className = 'doto-recently-viewed__card';
  article.setAttribute('data-doto-quick-add-card', '');

  const cheapestVariant = getCheapestVariant(product);
  const variantImage = getVariantImage(cheapestVariant, product);

  const link = document.createElement('a');
  link.className = 'doto-recently-viewed__link';
  link.href = getVariantUrl(product, cheapestVariant, config);
  link.setAttribute('aria-label', product.title || 'Ver producto');

  const media = document.createElement('div');
  media.className = 'doto-recently-viewed__media';

  if (variantImage) {
    const image = document.createElement('img');
    image.className = 'doto-recently-viewed__image';
    image.src = imageWithWidth(variantImage, 520);
    image.alt = product.title || '';
    image.loading = 'lazy';
    image.decoding = 'async';
    media.appendChild(image);
  }

  const badge = makeTextElement('span', 'doto-recently-viewed__badge', 'Visto recientemente');
  media.appendChild(badge);

  const content = document.createElement('div');
  content.className = 'doto-recently-viewed__content';

  if (config.showVendor && product.vendor) {
    content.appendChild(makeTextElement('div', 'doto-recently-viewed__vendor', product.vendor));
  }

  content.appendChild(makeTextElement('h3', 'doto-recently-viewed__product-title', product.title || ''));

  const priceRow = document.createElement('div');
  priceRow.className = 'doto-recently-viewed__price-row';

  const formatter = moneyFormatter(config.currency, config.locale);
  const priceValue = Number(cheapestVariant?.price || product.price || 0) / 100;
  const compareValue = Number(cheapestVariant?.compare_at_price || 0) / 100;
  const priceText = formatter.format(priceValue);

  priceRow.appendChild(makeTextElement('span', 'doto-recently-viewed__price', priceText));

  if (config.showComparePrice && compareValue > priceValue) {
    priceRow.appendChild(
      makeTextElement('span', 'doto-recently-viewed__compare-price', formatter.format(compareValue))
    );
  }

  content.appendChild(priceRow);

  if (!product.available) {
    content.appendChild(makeTextElement('span', 'doto-recently-viewed__sold-out', 'Agotado'));
  }

  link.appendChild(media);
  link.appendChild(content);
  article.appendChild(link);
  article.appendChild(createQuickAdd(product, config));

  return article;
}

async function fetchProduct(handle, rootUrl) {
  const root = (rootUrl || '/').replace(/\/$/, '');
  const response = await fetch(`${root}/products/${encodeURIComponent(handle)}.js`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  });

  if (!response.ok) {
    throw new Error(`Product fetch failed: ${response.status}`);
  }

  return response.json();
}

function syncArrows(section) {
  const track = section.querySelector('[data-rv-track]');
  const prev = section.querySelector('[data-rv-prev]');
  const next = section.querySelector('[data-rv-next]');

  if (!track || !prev || !next) return;

  const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
  prev.disabled = track.scrollLeft <= 4;
  next.disabled = track.scrollLeft >= maxScroll - 4 || maxScroll <= 4;
}

function bindArrows(section) {
  const track = section.querySelector('[data-rv-track]');
  const prev = section.querySelector('[data-rv-prev]');
  const next = section.querySelector('[data-rv-next]');

  if (!track || !prev || !next || section.dataset.rvArrowsBound === 'true') return;

  section.dataset.rvArrowsBound = 'true';

  const scrollAmount = () => {
    const firstCard = track.querySelector('.doto-recently-viewed__card');
    if (!firstCard) return track.clientWidth * 0.8;

    const styles = getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0');
    return firstCard.getBoundingClientRect().width + gap;
  };

  prev.addEventListener('click', () => {
    track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });

  next.addEventListener('click', () => {
    track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => syncArrows(section));
  }, { passive: true });

  window.addEventListener('resize', () => syncArrows(section), { passive: true });
}

function keepEditorPreview(section) {
  if (section.dataset.editorPreview !== 'true') return false;
  section.hidden = false;
  bindArrows(section);
  window.requestAnimationFrame(() => syncArrows(section));
  return true;
}

async function initRecentlyViewed(section) {
  if (!section || section.dataset.rvReady === 'true') return;
  section.dataset.rvReady = 'true';

  const track = section.querySelector('[data-rv-track]');
  if (!track) return;

  const limit = Number(section.dataset.limit || 8);
  const currentHandle = section.dataset.currentHandle || '';
  const rootUrl = section.dataset.rootUrl || '/';

  const config = {
    rootUrl,
    sectionId: section.dataset.sectionId || '',
    currency: section.dataset.currency || 'MXN',
    locale: section.dataset.locale || 'es-MX',
    hideSoldOut: section.dataset.hideSoldOut === 'true',
    showVendor: section.dataset.showVendor === 'true',
    showComparePrice: section.dataset.showComparePrice === 'true'
  };

  const handles = [...new Set(getRecentlyViewedHandles())]
    .filter((handle) => handle !== currentHandle)
    .slice(0, Math.max(limit * 2, limit));

  if (handles.length === 0) {
    keepEditorPreview(section);
    return;
  }

  const results = await Promise.allSettled(
    handles.map((handle) => fetchProduct(handle, rootUrl))
  );

  const products = results
    .filter((result) => result.status === 'fulfilled')
    .map((result) => result.value)
    .filter((product) => !config.hideSoldOut || product.available)
    .slice(0, limit);

  if (products.length === 0) {
    keepEditorPreview(section);
    return;
  }

  const fragment = document.createDocumentFragment();
  products.forEach((product) => {
    fragment.appendChild(createProductCard(product, config));
  });

  track.replaceChildren(fragment);
  section.hidden = false;

  bindArrows(section);
  window.requestAnimationFrame(() => syncArrows(section));
}

function initAllRecentlyViewed(root = document) {
  root.querySelectorAll?.('[data-doto-recently-viewed]').forEach((section) => {
    initRecentlyViewed(section).catch(() => {
      if (!keepEditorPreview(section)) {
        section.hidden = true;
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllRecentlyViewed());
} else {
  initAllRecentlyViewed();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllRecentlyViewed(event.target);
});
